const SocketEnum = {
  Notifications: "notifications",
  TestSocket: "testSocket",

  ComponentOne: "ComponentOne",
  ComponentTwo: "ComponentTwo",
}

export default SocketEnum;